export const parseTierIncrement = (value) => {
  if (value == null || value === "") return 1;
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return 1;
  return Math.floor(parsed);
};
